const NewPropertyFlag = () => (
  <div className="property-card-flag property-card-flag--new-property" data-test-reference="new-property-flag">
    <div className="property-card-flag--emphasized-text">NEW</div>
  </div>
);

export default NewPropertyFlag;
